export default function EmptyPreconReportIcon() {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* document */}
      <rect
        x="10"
        y="8"
        width="38"
        height="48"
        rx="3"
        fill="currentColor"
        opacity="0.08"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      {/* folded corner */}
      <path
        d="M36 8 L48 20 L36 20 Z"
        fill="currentColor"
        opacity="0.15"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      {/* title line */}
      <line
        x1="16"
        y1="28"
        x2="42"
        y2="28"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      {/* body lines */}
      <line
        x1="16"
        y1="35"
        x2="42"
        y2="35"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <line
        x1="16"
        y1="41"
        x2="35"
        y2="41"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      {/* clock / pending badge */}
      <circle
        cx="47"
        cy="47"
        r="11"
        fill="var(--bg2, #fff)"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <line
        x1="47"
        y1="41"
        x2="47"
        y2="47"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <line
        x1="47"
        y1="47"
        x2="51"
        y2="51"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
